import { useLazyQuery } from '@apollo/client'
import { createContext, useContext, useEffect, useState } from 'react'
import { GET_USER } from '../graphql/query'

const AuthContex = createContext()

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const token = localStorage.getItem('xand_user')
    const [getUser, { data }] = useLazyQuery(GET_USER)

    useEffect(() => {
        if (token) {
            getUser()
        } else {
            setUser("No Auth")
        }
    }, [token])

    return (
        <AuthContex.Provider value={{ user: data?.getUser || user }}>
            {children}
        </AuthContex.Provider>
    )
}

export const useAuth = () => useContext(AuthContex)